import { bl_wf_md_action_RowClass, bl_wf_md_action_RowInterface } from "../../../dbschema";
import {BaseContainerModel} from "../../base-container.model";

export class WfMdActionContainerModel extends BaseContainerModel{
  bl_wf_md_action: bl_wf_md_action_RowInterface = new bl_wf_md_action_RowClass();
}
